import { useState } from "react";
import FieldsPane from "../../components/settings/user/fields/FieldsPane";
import TeamPane from "../../components/settings/user/Team/TeamPane";
import EmailConfigPane from "../../components/settings/user/email/EmailConfigPane";
import { useUpgradeModal } from "../../context/UpgradeModalContext";

const UserSettings = () => {
  const paneTitles = ["Team", "Fields", "Tenant based configuration"];
  const [openedPane, setOpenedPane] = useState("Team");
  const { openUpgradeModal } = useUpgradeModal();
  const renderPane = () => {
    switch (openedPane) {
      case "Team":
        return <TeamPane />;
      case "Fields":
        return <FieldsPane />;
      case "Tenant based configuration":
        return <EmailConfigPane />;
      default:
        return <h4>Select tab to proceed</h4>;
    }
  };


  const planName = localStorage.getItem("planName") || "";
  const isFreeOrFreemium =
    planName === "Free" || planName === "Freemium";

  const handleTabClick = (title: string) => {
    if (isFreeOrFreemium && title === "Tenant based configuration") {
      openUpgradeModal();
    } else {
      setOpenedPane(title);
    }
  };

  return (
    <div>
      <div className="text-center">
        {/* Tabs */}
        <ul className="nav nav-stretch nav-line-tabs text-primary border-transparent d-flex flex-nowrap mb-5">
          {paneTitles.map((title) => {
            const isDisabled = isFreeOrFreemium && title === "Tenant based configuration";
            return (
              <li key={title} className="nav-item pb-0">
                <span
                  className={`nav-link fs-4 fw-bold ${openedPane === title ? 'active fw-bolder' : ''} ${
                    isDisabled ? 'text-muted' : 'cursor-pointer'
                  }`}
                  onClick={() => handleTabClick(title)}
                  role="tab"
                  style={isDisabled ? { cursor: 'pointer', opacity: 0.6 } : {}}
                >
                  {title}
                </span>
              </li>
            );
          })}
        </ul>

        {/* Content */}
        <div className="card-body px-1 px-lg-10 pt-0">{renderPane()}</div>
      </div>
    </div>
  );
};

export default UserSettings;
